const navigationBase = (path: string, params: Map<string, string>) => {
  const queryParams = new URLSearchParams()
  params.forEach((value, key) => {
    queryParams.append(key, value)
  })

  window.location.href = `${path}?${queryParams.toString()}`
}

export const navigationToPremiumPayment = (params: Map<string, string>) => {
  const path = '/premium/payment'
  navigationBase(path, params)
}

export const navigationToPremiumPlansAlbums = (params: Map<string, string>) => {

  const path = '/premium/plans/albums'
  navigationBase(path, params)
}

export const PLAN_SELECTION_FROM = 'plan_selection'
